<template>
  <div style="margin-bottom:20px">
    <h3 class="ui dividing header">
      <i class="thumbs up icon"></i>
      <div class="content">
         Līdzīgas preces
      </div>
    </h3>

      <div  id= "replac" class="ui stackable three cards">

          <div v-for="item in goods" :key="item.id" class="ui fluid card">
            <discount-tag v-bind:item="item"></discount-tag>
            <div @click="$router.push('/good/'+item.link)" style="cursor:pointer">
              <img class="ui centered image" v-if="item.images[0]" :src="item.images[0].url" />
              <img class="ui centered image" v-else :src="'https://res.cloudinary.com/mwsuite/image/upload/f_auto,w_170,h_250,c_lfill/product/'+item.id+'.jpg'" />
            </div>
            <div class="content">
              <router-link :to="'/good/'+item.link" style="margin-bottom:5px" class="header">{{item.goods_name}}</router-link>

              <div class="meta">
                <div class="ui tag labels pa-tag-wrapper">
                <price-tag v-bind:item="item"></price-tag>
                <a v-if="item.bail>0" class="ui green label">
                  Drošības nauda: {{item.bail}} &euro;
                </a>
                <auto-ship v-bind:item="item"></auto-ship>
                </div>
              </div>
              <div class="description">
                {{item.description}}
              </div>
            </div>


            <button v-if="!checkIfInCart(item)" @click="addItemToCart(item)" class="ui bottom attached button">
              <i class="add icon"></i> Pievienot
            </button>

            <div v-else class="ui three bottom attached  buttons">
             <div class="ui  button" @click="reduceItemInCart(item)">
               <i class="minus icon"></i>
             </div>
             <button v-on:click="$router.push({name:'cart'})" class="ui  vertical animated button" >
           <div class="ui hidden content" >Uz grozu</div>
           <div class="ui visible content">
             <i class="cart icon"></i> {{howManyInCart(item)}} gab.
           </div>
           </button>

             <div class="ui  button" @click="addItemToCart(item)">
               <i class="add icon" :id="'top_goods_'+item.id" data-content="Diemžēl pieejamo preču skaits noliktavā ir ierobežots, lūdzu apskatiet līdzīgās preces"></i>
             </div>
            </div>
          </div>
      </div>

      <!-- <div class="ui container" style="margin-top:20px">
       <button @click="$router.push({name: 'goods'})" class="ui right floated green button">Apskatīt vairāk <i class="arrow right icon"></i></button>
       <div class="ui clearing hidden divider"></div>
      </div> -->

  </div>
</template>

<script>

import autoShip from './AutoShip';
import price from './Price';
import discount from './Discount';


export default {
    name:"replacement_goods",
    props:["goods","title"],
  computed: {
    // goods() {
    //   //loaded from parent
    //   return this.$store.state.goodStore.topgoods
    // },
    cart() {
      return this.$store.state.cartStore.activeCart
    },
    cartItems() {
        return this.$store.state.cartStore.items
    },
  },
  components: {
      'auto-ship': autoShip,
      'price-tag': price,
      'discount-tag': discount
  },

  methods:{


    checkIfInCart(item){

       if(this.$store.state.cartStore.items.length > 0 && this.$store.state.cartStore.items.filter(function(e) { return e.good_id == item.id }).length > 0) return true;
       else return false;
    },
    howManyInCart(item){
      if(this.checkIfInCart(item)){
        var cartItem = this.$store.state.cartStore.items.filter(function(e) { return e.good_id == item.id });
        item.autoship_price = cartItem[0].autoship_price;
        return cartItem[0].order;
      }
      else return 0;
    },
    realPrice(item){
      if(this.checkIfInCart(item)){
        var cartItem = this.$store.state.cartStore.items.filter(function(e) { return e.good_id == item.id });
        return cartItem[0].price_vat;
      }
      else return item.base_price_vat;
    },
    gotoCart(){
      this.$router.push({
        name: 'cart',
      });
    },
    addItemToCart(item){
      var itemInCart = this.checkIfInCart(item);
      if(itemInCart){
        var cartItem = this.$store.state.cartStore.items.filter(function(e) { return e.good_id == item.id });
        var updatedItem = JSON.parse(JSON.stringify(cartItem[0])); //copy object
        updatedItem.order ++;
      }
      else{
        var updatedItem = {
          order:1,
          good_id:item.id
        }
      }

      this.$store.dispatch('addCartItem', [this.cart.id, updatedItem]).then((response) => {

        //show popup that we are out of goods
        if(response.data.data.order < updatedItem.order) {
          $('#top_goods_'+item.id).popup('show')
          setTimeout(function () { $('#top_goods_'+item.id).popup('destroy'); }.bind(this), 3000)
        }
        else{
          $('#top_goods_'+item.id).popup('destroy'); //remove warning about warehouse goods
        }

        item.autoship_price = response.data.data.autoship_price;
        this.$store.dispatch('loadActiveCart', this.cart.id);
      }).catch((error) => {

        console.error('Cart was not loaded')
      });

    },

    reduceItemInCart(item){

      $('#top_goods_'+item.id).popup('destroy'); //remove warning about warehouse goods

      var itemInCart = this.checkIfInCart(item);
      if(itemInCart){
        var cartItem = this.$store.state.cartStore.items.filter(function(e) { return e.good_id == item.id });
        var updatedItem = JSON.parse(JSON.stringify(cartItem[0])); //copy object
        updatedItem.order --;

        this.$store.dispatch('addCartItem', [this.cart.id, updatedItem]).then((response) => {
          item.autoship_price = response.data.data.autoship_price;
          //if item is totaly removed then remove it from store
          this.$store.dispatch('loadActiveCart', this.cart.id);
        }).catch((error) => {

          console.error('Cart was not loaded')
        });

      }
    }
  }
}
</script>

<style scoped>

  .ui.dividing.header {
    border: none;
    border-bottom: none;
  }
</style>


// WEBPACK FOOTER //
// ReplacementGoods.vue?e3217efa